import {
  Input as AntDesignInput,
  InputNumber as AntDesignInputNumber,
} from 'antd';
import cx from 'classnames';
import React from 'react';
import { MdClear } from 'react-icons/md';

const { TextArea: AntDesignTextArea } = AntDesignInput;

type InputProps = {
  PrefixIcon?: React.ElementType;
  onChange?: (value: string | null | number) => void;
  placeholderText?: string;
  disabled?: boolean;
  customInputClassName?: string;
  value?: string;
  type?: 'default' | 'number' | 'textArea' | 'password';
  size?: 'small' | 'middle' | 'large';
  rows?: number;
  minValue?: string;
  maxValue?: string;
  inputNumberStep?: number;
  precision?: number;
};

const Input: React.FC<InputProps> = ({
  PrefixIcon,
  onChange,
  placeholderText,
  disabled,
  value = undefined,
  type = 'default',
  size,
  rows = 6,
  customInputClassName,
  minValue,
  maxValue,
  inputNumberStep,
  precision,
}) => {
  const sharedProps = {
    size,
    disabled,
    placeholder: placeholderText,
    className: cx(
      'tw-w-full !tw-shadow-none tw-bg-[--surface-background]',
      {
        '!tw-bg-[--color-button-disabled]': disabled,
      },
      customInputClassName,
    ),
  };

  const prefixIcon = PrefixIcon ? (
    <PrefixIcon color="var(--color-text-weakest)" size={20} />
  ) : undefined;

  switch (type) {
    case 'number':
      return (
        <AntDesignInputNumber
          {...sharedProps}
          onChange={(numberVal) => onChange?.(numberVal)}
          value={value}
          min={minValue}
          max={maxValue}
          step={inputNumberStep}
          precision={precision}
        />
      );

    case 'textArea':
      return (
        <AntDesignTextArea
          {...sharedProps}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
            onChange?.(e.target.value)
          }
          value={value}
          rows={rows}
        />
      );
    case 'password':
      return (
        <AntDesignInput.Password
          {...sharedProps}
          prefix={prefixIcon}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onChange?.(e.target.value)
          }
          visibilityToggle
        />
      );

    default:
      return (
        <AntDesignInput
          {...sharedProps}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onChange?.(e.target.value)
          }
          allowClear={{
            clearIcon: <MdClear color="var(--color-text-weakest)" size={20} />,
          }}
          prefix={prefixIcon}
          value={value}
        />
      );
  }
};

export default Input;
